export enum DaysOfWeek {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7
}

export enum IdentificationCodesDisplay {
    Dea = "DEA [11]",
    Hin = "HIN [21]",
    Duns = "DUNS [1]",
    Duns4 = "DUNS+4 [9]",
    BuyerId = "Buyer ID [92]",
    SellerId = "Seller ID [91]",
    Gln = "GLN [UL]",
    Zz = "Undefined [ZZ]",
}

export type IdentificationCodeQualifier = keyof typeof IdentificationCodesDisplay;
